
// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueMask from 'v-mask'
import VUppercase from 'v-uppercase'
import zhHant from 'vuetify/es5/locale/zh-Hant'
import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify)
Vue.use(VueMask);
Vue.use(VUppercase);

const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#8CC63F',
          secondary: '#009964',
          darken1: '#414042',
        },
      },
    },
    lang: {
      locales: { zhHant, en },
      current: 'zhHant',
    },
    icons: {
      iconfont: 'mdiSvg',
    },
  })

export default vuetify